



































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import ContestList from '../../../shared/components/ContestList.vue';
import MatchCarousel from '../../../shared/components/MatchCarousel.vue';
import IMatchCarouselItem from '../../../shared/models/IMatchCarouselItem';
import ContestListLike from '../../../shared/models/ContestList'
import RangeSlider from '../components/RangeSlider.vue'

import lobbyService from '../services/LobbyService';
import { CompetitionItem } from "@/modules/lobby/types";
import LoadingContestList from '@/shared/components/ui/LoadingContestList.vue';
import { pad } from "@/shared/utils";
import {IContestPagination} from "@/shared/types";

@Component({
    components: {
        ContestList,
        MatchCarousel,
        RangeSlider,
        VueSlider,
        LoadingContestList
    },
})
export default class Lobby extends Vue {
    private filters = {
        price: [0, 100],
        competition: 0,
        page: 1,
    };
    private price = [0, 100];
    private types = [
        {
            id: 1,
            name: "Todos",
        }, {
            id: 3,
            name: "Contest",
        },
    ];
    private selectedType = 1;
    private competitions: CompetitionItem[] = [];
    private totalContests = 0;
    private list: ContestListLike = {
        title: "Recommended for you",
        description: "Contests catered to you",
        items: [],
        total: 0,
        nextpage: "",
    };

    private callPad(time: string) {
        return pad(time, 2)
    }

    private handleMatchClick(competitionId: any) {
        this.filters.competition = competitionId;
    }

    private get joiningContestId() {
        return this.$route.query['joiningContestId']
    }

    private async mounted() {
        await this.getCompetitions();
        this.getMatches();
        this.getContests();
    }

    private matches: IMatchCarouselItem[] = [];

    private get veryNextMatch() {
        if (!this.matches.length) {
            return
        }

        return this.matches[0];
    }

    private get veryNextMatchTime() {
        if (!this.matches.length) {
            return new Date()
        }
        // @ts-ignore
        const nextMatchTime = new Date(this.matches[0].startedAt).getTime() - new Date().getTime();

        if (nextMatchTime < 0) {
            return 0
        }

        return nextMatchTime
    }

    private get formattedContestsFilters() {
        const filters: any = {};
        filters.status = 1;
        filters['itemsPerPage'] = 5;
        filters['moneyAmount[between]'] = `${this.filters.price[0] * 100}..${this.filters.price[1] * 100}`;

        if (this.filters.competition && this.filters.competition !== 0) {
            filters.competition = this.filters.competition;
        }

        return filters;
    }

    private get formattedMatchesFilters() {
        const filters: any = {};
        // @ts-ignore
        filters['startedAt[strictly_after]'] = this.$moment().format('YYYY-MM-DD');
        filters['pagination'] = 'true';
        filters['order[startedAt]'] = 'asc';

        if (this.filters.competition) {
            filters.competition = this.filters.competition;
        }

        return filters;
    }

    @Watch('filters.competition')
    async onCompetitionChanged() {
        this.list = {...this.list, items: []};
        this.resetPagination();
        await this.getMatches();
        await this.getContests();
    }

    // @Watch('filters.price')
    async onPriceFilterChange() {
        this.list = {...this.list, items: []};
        this.resetPagination();
        await this.getContests()
    }

    private resetPagination() {
        this.totalContests = 0;
        this.contestPagination = {
            nextPlayerPage: null,
            isLastPage: false,
            canFetchMore: true,
            loading: true,
        }
    }

    private contestPagination: IContestPagination = {
        nextPlayerPage: null,
        isLastPage: false,
        canFetchMore: true,
        loading: true,
    };

    private async handleLoadMoreContests() {
        await this.getContests();
    }

    async getContests() {
        if (!this.contestPagination.canFetchMore) {
            return;
        }

        this.contestPagination.loading = true;
        const contestsData: any = await lobbyService.fetchContests(this.formattedContestsFilters, this.contestPagination.nextPlayerPage);
        this.contestPagination.nextPlayerPage = contestsData.nextpage;
        this.totalContests = contestsData.totalItems;

        if (!contestsData.nextpage) {
            this.contestPagination.isLastPage = true;
            this.contestPagination.canFetchMore = false;
        }

        this.totalContests = contestsData.total;
        const items: any[] = contestsData.items;
        this.list = {...this.list, items: [...this.list.items, ...items]};
        this.contestPagination.loading = false;
    }

    async getCompetitions() {
        this.competitions = await lobbyService.fetchCompetitions();
    }

    async getMatches() {
        this.matches = [];
        this.matches = await lobbyService.fetchMatches(this.formattedMatchesFilters);
    }

}
